import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { SupportChat } from "./SupportChat";
import { Logo } from "./Logo";
import { LanguageMenu, CurrencyMenu } from "./Selectors";
import { useApp } from "../context/AppContext";

import { tx, useLang } from "../lib/i18n";
export const Footer = () => { useLang();
  const { t } = useApp();
  const [co, setCo] = useState(null);
  useEffect(() => { api.get("/site/company").then((r) => setCo(r.data)).catch(() => {}); }, []);
  return (
    <footer className="mt-24 border-t border-[var(--mv-border)] bg-[var(--mv-bg-2)]" data-testid="site-footer">
      <div className="mv-container grid gap-10 py-14 md:grid-cols-6">
        <div className="md:col-span-2 space-y-5">
          <Logo />
          <div className="flex flex-wrap gap-2"><LanguageMenu /><CurrencyMenu /></div>
          {co && (co.support_email || co.phone || co.address) && (
            <div className="space-y-1 text-xs text-[var(--mv-dim)]" data-testid="footer-contact">
              {co.support_email && <a href={`mailto:${co.support_email}`} className="block hover:text-[var(--mv-teal)]" data-testid="footer-support-email">{co.support_email}</a>}
              {co.phone && <a href={`tel:${co.phone.replace(/\s/g, "")}`} className="block hover:text-[var(--mv-teal)]" data-testid="footer-phone">{co.phone}</a>}
              {co.address && <p className="whitespace-pre-line">{co.address}</p>}
            </div>
          )}
          {co && Object.keys(co.socials).length > 0 && (
            <div className="flex flex-wrap gap-3 text-xs" data-testid="footer-socials">
              {Object.entries(co.socials).map(([k, v]) => <a key={k} href={v} target="_blank" rel="noopener noreferrer" className="capitalize text-[var(--mv-dim)] hover:text-[var(--mv-teal)]" data-testid={`footer-social-${k}`}>{k}</a>)}
            </div>
          )}
        </div>
        <div className="md:col-span-4" data-testid="footer-seller-cta">
          <div className="mv-cta-pulse relative overflow-hidden rounded-3xl border border-[var(--mv-teal)]/40 bg-[radial-gradient(circle_at_85%_20%,rgba(0,229,188,0.14),transparent_60%)] p-7">
            <p className="text-[11px] tracking-[0.3em] text-[var(--mv-teal)]">{tx("SELLER SERVICES")}</p>
            <p className="mt-2 text-2xl font-semibold">{tx("Sell with MIVO")}</p>
            <p className="mt-2 max-w-lg text-sm text-[var(--mv-muted)]">{tx("Open your own store, list your products or offer approved MIVO catalog items, and reach MIVO shoppers. Every store is reviewed and approved by MIVO before it goes live.")}</p>
            <div className="mt-5 flex flex-wrap items-center gap-4">
              <Link to="/sellers/apply" className="mv-btn-primary rounded-full px-6 py-3 text-sm" data-testid="footer-open-store">{tx("Open Your Store")}</Link>
              <Link to="/sellers" className="text-sm text-[var(--mv-teal)] hover:underline" data-testid="footer-seller-services">{tx("Seller Services →")}</Link>
              <Link to="/stores-for-sale" className="text-sm text-[var(--mv-muted)] hover:text-[var(--mv-teal)]" data-testid="footer-stores-for-sale">{tx("Stores for sale")}</Link>
              <Link to="/wholesale" className="text-sm text-[var(--mv-muted)] hover:text-[var(--mv-teal)]" data-testid="footer-wholesale">{tx("Wholesale")}</Link>
            </div>
          </div>
        </div>
      </div>
      <nav aria-label={tx("Legal & Help")} className="mv-container flex flex-wrap items-center gap-x-5 gap-y-2 pb-6 text-xs text-[var(--mv-dim)]" data-testid="footer-legal-help">
        <span className="font-semibold uppercase tracking-[0.14em] text-[var(--mv-muted)]">{tx("Legal & Help")}</span>
        {(co?.policies || []).map((p) => <Link key={p.key} to={`/policies/${p.key}`} className="hover:text-[var(--mv-teal)]" data-testid={`footer-policy-${p.key}`}>{tx(p.title)}</Link>)}
        {[["/about", "About MIVO"], ["/help", "Help"], ["/track-order", "Track Order"]].map(([to, l]) => <Link key={to} to={to} className="hover:text-[var(--mv-teal)]" data-testid={`footer-link-${to.slice(1)}`}>{tx(l)}</Link>)}
      </nav>
      <div className="border-t border-[var(--mv-border)]">
        <p className="mv-container py-5 text-xs text-[var(--mv-dim)]">© {new Date().getFullYear()} {co?.legal_name || tx("MIVO.")} {t("footer.rights")} {t("footer.ratesNote")}</p>
      </div>
    </footer>
  );
};

export const FloatingUtilities = () => { useLang();
  return (
    <>
      <div className="fixed bottom-5 left-5 z-30 hidden md:block" data-testid="floating-currency-widget">
        <CurrencyMenu className="bg-[rgba(16,23,24,.85)] backdrop-blur py-1.5" />
      </div>
      <SupportChat />
    </>
  );
};
